import React, { useEffect, useContext, useState } from "react";

import { faPenToSquare, faTrash, faAdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import addIcon from '../../assets/images/add-icon.svg'




import { deleteWithAuthCall, simpleGetCallWithToken } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { ToastMsg } from "../TostMsg";
import Loader from "./loader";
import NoDataFound from "./NodataFound";
import { AppContext } from "../../context/AppContext";
import Pagination from "./Pagination";
import SelectDomain from "../../component/SelectDomain";







const getChatRs = [
  {
    sender_id: "user1",
    last_message: "Hello, how can I help you?",
    timestamp: "2024-07-21T12:34:56.789Z",
  },
  {
    sender_id: "user2",
    last_message: "I need assistance with my order.",
    timestamp: "2024-07-21T12:35:56.789Z",
  },
  {
    sender_id: "user3",
    last_message: "Can you provide more details on your service?",
    timestamp: "2024-07-21T12:36:56.789Z",
  },
];

const getChatDetails = {
  events: [
    {
      type_name: "user",
      timestamp: 1675970400,
      data: {
        text: "Hello, how can I help you today?",
      },
    },
    {
      type_name: "bot",
      timestamp: 1675970460,
      data: {
        text: "I need some details about your issue.",
      },
    },
    {
      type_name: "user",
      timestamp: 1675970520,
      data: {
        text: "I have a problem with my order.",
      },
    },
    {
      type_name: "bot",
      timestamp: 1675970580,
      data: {
        text: "Can you provide me with your order number?",
      },
    },
    {
      type_name: "system", // This type will be filtered out
      timestamp: 1675970640,
      data: {
        text: "System maintenance in progress.",
      },
    },
  ],
};

// Assuming you have a CSS file for styling


const TestunAnsweredCase = () => {
  const [selectedChat, setSelectedChat] = useState(undefined);
  const [selectedChatDetails, setSelectedChatDetails] = useState(undefined);
  const [chats, setChats] = useState([]);
  const [questionList, setQuestionList] = useState([]);

  const [totalPage, setTotalPage] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  const [search, setSearch] = useState({
    moduleName: '',
    subModuleName: ''
  })

  const { sidebar, selectedDomainId, domainName, setBackTo, permissions } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true)

  const [total, setTotal] = useState(0)


  const navigate = useNavigate();

  const [startIndex, setStartIndex] = useState(0)

  const handleChatClick = (selectedChat) => {
    setSelectedChat(selectedChat);
    // setSelectedChatDetails(undefined);

    setSelectedChatDetails(getChatDetails);
    // RasaAdminAPI.getChat(selectedChat.sender_id).then(data => {
    // });
  };

  const handleSendMessage = (text) => {
    const data = {
      type_name: "bot", // This type will be filtered out
      timestamp: 1675970640,
      data: {
        text: "System maintenance in progress.",
      },
    };
    const data2 = {
      type_name: "user", // This type will be filtered out
      timestamp: Math.floor(Math.random() * 100000000),
      data: {
        text: text,
      },
    };

    setSelectedChatDetails((prev) => ({
      ...prev,
      events: [...prev.events, data2, data],
    }));
    // console.log(`send message: ${text} to ${selectedChat.sender_id}`);
    // RasaAdminAPI.sendMessage(selectedChat.sender_id, text);
  };

  useEffect(() => {
    // Fetch chat collection
    // RasaAdminAPI.getChats().then(data => setChats(data));
    setChats(getChatRs);
    getUnAnswerdQuestionList();
  }, [selectedDomainId, currentPage]);


  function getUnAnswerdQuestionList() {
    setIsLoading(true)
    simpleGetCallWithToken(ApiConfig.GET_UN_ANSWERED_TEST_LIST + `domain_id=${selectedDomainId}&page=${currentPage}&page_limit=25&sub_modulename=${search?.subModuleName}&module_name=${search?.moduleName}`)
      .then((res) => {

        if (res.success) {

          setTotal(res?.total_counts)
          setTotalPage(res?.total_pages)
          setQuestionList(res.data)
          //setStartIndex((currentPage - 1) * 10)
        } else {
          setQuestionList([])
        }
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false)
      })
  }





  return (
    <div className="main_container">

      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >


        <div >
          <div className="role-content">
            <div className="sub-header-role d-flex justify-content-between">
              <h6 className="mt-2">Intent Without Test Cases {total}</h6>
              <div className="d-flex">
                <h6 className="mt-2 mr-2">Domain Name : {domainName}</h6>
                <SelectDomain />
              </div>
            </div>
            <div className="input_wraper d-flex mt-4">
              <input
                placeholder="Search By Module Name"
                type="text"
                className=""
                style={{ width: '250px', height: "38px" }}
                value={search.moduleName}
                onChange={(e) => setSearch(prev => ({
                  ...prev,
                  moduleName: e.target.value
                }))}
              />
              <input
                placeholder="Search By Sub Module Name "
                type="text"
                className="ml-2"
                style={{ width: '250px', height: "38px" }}
                value={search?.subModuleName}
                onChange={(e) => setSearch(prev => ({
                  ...prev,
                  subModuleName: e.target.value
                }))}
              />
              <button className="AddQuestion_submit_btn mx-3"
                onClick={getUnAnswerdQuestionList}
              >Search</button>
            </div>
            <div className="table-wrapper table-wrapper-2" style={{ height: "600px" }}>
              {
                isLoading ? <Loader /> :
                  questionList.length > 0 ?

                    <table style={{ marginBottom: "20px" }}>
                      <thead className="">
                        <tr className="firstTabelRow">
                          <th>Sr. no</th>
                          <th>Intent Name</th>
                          <th>Module Name</th>
                          {/* <th>Answer</th> */}
                          <th>Sub Module</th>
                          {
                            permissions && permissions['Create Test Case'] &&

                            <th>Action</th>
                          }
                        </tr>
                      </thead>
                      {questionList.map((item, index) => (
                        <tr key={index} className="table-row-custom">
                          <td>{startIndex + index + 1} </td>
                          <td>{item?.intent}</td>
                          <td>{item?.module_name} </td>
                          <td>{item?.sub_modulename}</td>
                          {/* <td>{item?.question_text} </td> */}
                          {
                            permissions && permissions['Create Test Case'] &&
                            <td>
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 100, hide: 300 }}
                                overlay={(props) => (
                                  <Tooltip id="button-tooltip" {...props}>
                                    Add Test Case
                                  </Tooltip>
                                )}
                              >
                                <FontAwesomeIcon
                                  onClick={() => {
                                    //   setBackTo('/unAnsweredListing')
                                    navigate("/EditCase/")
                                  }}
                                  icon={faAdd}
                                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                                />
                              </OverlayTrigger>{" "}


                            </td>
                          }
                        </tr>
                      ))}
                    </table> : <NoDataFound />
              }
            </div>
            <Pagination
              totalPage={Number(totalPage)}
              currentPage={currentPage}
              pageChangeHandler={(page) => setCurrentPage(page + 1)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestunAnsweredCase
